const fontAwesomeLink = document.createElement("link");
fontAwesomeLink.rel = "stylesheet";
fontAwesomeLink.href = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css";
document.head.appendChild(fontAwesomeLink);

const sa = document.createElement("script");
sa.type = "text/javascript";
sa.src = "https://cdn.jsdelivr.net/npm/sweetalert2@11";
document.head.appendChild(sa);

localStorage.removeItem("id");
localStorage.removeItem("pi");

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const hasOrderProcessingParam = urlParams.get("payment_intent");
const hasEuCoIdParam = urlParams.get("id");

function saveUTMToLocalStorage() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const utm = {};
    const utmParams = {
        "utm_medium": "utm_medium",
        "utm_source": "utm_source",
        "utm_campaign": "utm_campaign",
        "utm_term": "utm_term",
        "utm_content": "utm_content",
        "ad_id": "ad_id",
        "ttclid": "ttclid",
        "fbclid": "fbclid",
    };

    for (const [paramName, key] of Object.entries(utmParams)) {
        const paramValue = urlParams.get(paramName);
        if (paramValue) {
            utm[key] = paramValue;
        }
    }

    const existingUTM = localStorage.getItem("utm");
    if (Object.keys(utm).length > 0 && !existingUTM) {
        localStorage.setItem("utm", JSON.stringify(utm));
    }
}

saveUTMToLocalStorage();

function setId() {
    localStorage.setItem("id", hasEuCoIdParam);
    localStorage.setItem("pi", hasOrderProcessingParam);
}

if (hasOrderProcessingParam && hasEuCoIdParam) {
    localStorage.removeItem("utm");

    function getId() {
        document.cookie = "cart=;expires=2021-12-19T15:12:13.000Z";
        let id = localStorage.getItem("id");
        let pi = localStorage.getItem("pi");
        return { id, pi };
    }

    setId();
    document.addEventListener("DOMContentLoaded", function () {
        function addStylesAndScripts() {
            if (!document.querySelector("#custom-loader-css")) {
                const style = document.createElement("style");
                style.id = "custom-loader-css";
                style.textContent = `
                    html, body {
                        height: 100%;
                        margin: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
    
                    .loader {
                        width: 30px;
                        height: 30px;
                        border: 4px solid black;
                        border-bottom-color: transparent;
                        border-radius: 50%;
                        display: inline-block;
                        box-sizing: border-box;
                        animation: rotation 1s linear infinite;
                    }
    
                    @keyframes rotation {
                        0% {
                            transform: rotate(0deg);
                        }
                        100% {
                            transform: rotate(360deg);
                        }
                    }
                `;
                document.head.appendChild(style);
            }
        }

        function addProcessingDiv() {

            var div = document.createElement('div');
            div.className = "full-screen-center";

            var p = document.createElement('p');
            p.className = "italic";
            p.textContent = "";

            var span = document.createElement('span');
            span.className = "loader";

            div.appendChild(p);
            div.appendChild(span);

            document.body.innerHTML = '';
            document.body.appendChild(div);
        }

        addStylesAndScripts();
        addProcessingDiv();

        (async () => {
            window.location.href = `https://${subdomain()}.${server()}/processing?&id=${getId().id}&payment_intent=${getId().pi}`;
        })();
    });

}

let intervalID;
async function stripe_checkout(e) {
    let str = window.Shopify.shop;
    let utmGet = localStorage.getItem('utm');
    intervalID = null;
    try {
        let n = window.location.origin;
        let o = await fetch(`${n}/cart.js`);
        let s = await o.json();
        s.utm = JSON.parse(utmGet);
        s.str = str || '';
        let a = await fetch(`https://${subdomain()}.${server()}/api/cartinfo`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(s)
        });
        let r = await a.json();
        if (r.type) {
            e.disabled = !1;
            e.innerText = "Reload & Try Again...";
            var t = document.createElement("p");
            t.id = "errorMessage";
            t.style.color = "red";
            t.style.display = "block";
            e.parentNode.insertAdjacentElement("afterend", t);
            document.getElementById("errorMessage").innerText = `${r?.raw?.message.split("(", 1)}`;
            Swal.fire({
                icon: "error",
                title: "Error...",
                color: "red",
                text: `${r?.raw?.message.split("(", 1)}` || "Something Went Wrong...",
                allowOutsideClick: false,
                confirmButtonText: 'OK'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });

            console.log(r?.raw?.message);
        } else {
            window.location.href = r.url;
        }
    } catch (t) {
        console.log(t);
        e.innerText = "Reload & Try Again...";
        e.disabled = !0;
    }
}

intervalID = setInterval(function () {

    function removeScriptsWithDataAttribute() {
        const scriptTags = document.querySelectorAll('script[data-checkify-url]');

        scriptTags?.forEach(script => {
            script.parentNode.removeChild(script);
        });
    }
    removeScriptsWithDataAttribute();

    if (!document.querySelector("#custom-loader-css")) {
        const style = document.createElement("style");
        style.id = "custom-loader-css";
        style.textContent = `
            .loader {
                width: 20px;
                height: 20px;
                border: 2px solid #FFF;
                border-bottom-color: transparent;
                border-radius: 50%;
                display: inline-block;
                box-sizing: border-box;
                animation: rotation 1s linear infinite;
            }

            @keyframes rotation {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
        `;
        document.head.appendChild(style);
    }

    const checkoutButtons = document.querySelectorAll('.upcart-checkout-button');
    checkoutButtons.forEach((checkoutButton) => {
        const newDiv = document.createElement('div');
        newDiv.setAttribute('sc', 'checkout');
        newDiv.className = 'styles_Button__fullWidth__uCmBU';
        newDiv.style.width = '100%';
        newDiv.style.backgroundColor = 'black';
        newDiv.style.color = 'white';
        newDiv.innerHTML = checkoutButton.innerHTML;
        checkoutButton.parentNode.replaceChild(newDiv, checkoutButton);
    });

    const e = document.querySelectorAll('.slide-cart-checkout-btn, [name="checkout"], [id="checkout"], [id="CartDrawer-Checkout"], [form="CartDrawer-Form"], a[href="/checkout"], a[href="checkout"],a[href="/checkout/"], a[href="checkout/"], [sc="checkout"], button[sc="checkout"], a[sc="checkout"]');
    e?.forEach((e) => {
        e?.removeAttribute("name");
        e?.removeAttribute("type");
        e?.removeAttribute("id");
        e?.setAttribute("sc", "checkout");
        e?.addEventListener("click", function (t) {
            t.preventDefault();
            e.disabled = !0;
            const loader = document.createElement("span");
            loader.className = "loader";
            e.innerHTML = "";
            e.appendChild(loader);
            intervalID && stripe_checkout(e);
        });
    });
}, 100);

function subdomain() {
    let url = "untangly";
    return url;
}

function server() { let server = "abcheckout.com"; return server; }

document.addEventListener('contextmenu', function (e) {
    e.preventDefault();
});

document.addEventListener('keydown', function (e) {
    if (e.key === 'F12') {
        e.preventDefault();
    }
});






          var css = 'div[data-shopify="payment-button"]{ display: none !important; } div[data-shopify="dynamic-checkout-cart"]{ display: none !important; }';
          var style = document.createElement('style');
          style.type = 'text/css';
          if (style.styleSheet) {
              style.styleSheet.cssText = css;
          } else {
              style.appendChild(document.createTextNode(css));
          }
          document.head.appendChild(style);
        